/**
 * Panel Vendedor IA para bandejas de producción (TwilioAgente).
 * No incluye Lab / simulación / navegación fuera de la vista.
 */
export default {
  data: () => ({
    panelIaMinimizado: true,
    tabIa: 0,
    marcaPrompt: 'INBI_CDMX',
    marcasPrompt: ['INBI_MTY', 'INBI_CDMX', 'INBI_GDL', 'FAST'],
    idAgenteSeleccionado: null,
    versionAgenteSeleccionada: null,
    agentesLista: [],
    versionesAgenteActivo: [],
    modoOperacionAgente: 'autonomo_sandbox',
    generandoBorrador: false,
    cargandoContexto: false,
    borradorActivo: null,
    borradores: [],
    contextoActivo: null,
    perfilActivo: null,
    controlEstado: null,
    cargandoControl: false,
    accionControl: false,
    limpiandoAgente: false,
    dialogLimpiarAgente: false,
    modoLimpiarAgente: 'contexto',
  }),

  computed: {
    puedeLimpiarAgenteIa() {
      const u = this.getdatosUsuarioERPERP
      if (!u) return false
      const ids = [1, 3, 568, 334, 3015, 2268, 2155, 2472, 1312, 2230, 954, 2767, 2910, 2574, 3176]
      return ids.includes(Number(u.iderp))
    },
    iaBloqueadaPorHumano() {
      const e = this.controlEstado
      if (!e) return false
      return !!(e.humano_tomo_control || e.control_conversacion === 'humano' || e.ia_puede_responder === false)
    },
    /** Composer humano solo con control tomado */
    composerBloqueadoPorIa() {
      return !!(this.chat && !this.iaBloqueadaPorHumano)
    },
    chipControlTexto() {
      const c = (this.controlEstado && this.controlEstado.control_conversacion) || 'ia'
      if (c === 'humano') return 'Control: tú'
      if (c === 'pausado') return 'Control: pausado'
      if (c === 'cerrado') return 'Control: cerrado'
      if (c === 'bot_perfilamiento') return 'Control: bot'
      return 'Control: IA'
    },
    chipControlColor() {
      const c = (this.controlEstado && this.controlEstado.control_conversacion) || 'ia'
      if (c === 'humano') return 'orange lighten-4'
      if (c === 'pausado' || c === 'cerrado') return 'grey lighten-3'
      return 'teal lighten-4'
    },
    etiquetaAgenteBarra() {
      const id = this.idAgenteSeleccionado
      if (!id) return this.marcaPrompt || 'elige agente'
      const ag = (this.agentesLista || []).find((a) => a.id_agente === id)
      const nombre = (ag && (ag.nombre_publico || ag.id_agente)) || id
      const ver = this.versionAgenteSeleccionada
      return ver != null && ver !== '' ? `${nombre} · v${ver}` : String(nombre)
    },
    agentesSelectItems() {
      return (this.agentesLista || []).map((a) => ({
        text: `${a.nombre_publico || a.id_agente} (${a.id_agente})`,
        value: a.id_agente,
      }))
    },
    versionesAgenteItems() {
      return (this.versionesAgenteActivo || [])
        .filter((v) => v.estado_version === 'publicado' || v.estado_version === 'borrador')
        .map((v) => ({
          text: `v${v.numero_version} · ${v.estado_version}`,
          value: String(v.numero_version),
        }))
    },
    mostrarBotonTomarControl() {
      return !!this.chat && !this.iaBloqueadaPorHumano
    },
    mostrarBotonDevolverIa() {
      return !!this.chat && this.iaBloqueadaPorHumano
    },
    idConversacionActiva() {
      if (!this.chat || !this.chat.usuario) return null
      const digits = String(this.chat.usuario).replace(/\D/g, '')
      return digits ? `CONV-${digits.slice(-10)}` : null
    },
    jsonContextoIa() {
      const ctx = this.contextoActivo && this.contextoActivo.contexto_ia
      return ctx && typeof ctx === 'object' ? ctx : null
    },
    contextoIaResumen() {
      if (!this.jsonContextoIa) {
        return JSON.stringify({
          nota: 'Cargando contexto… Si no aparece, abre ⚙ y usa Cargar contexto.',
        }, null, 2)
      }
      return JSON.stringify(this.jsonContextoIa, null, 2)
    },
    payloadIaBase() {
      if (!this.chat) return null
      const peer = this.chat.usuario
      const base = {
        fuente: 'produccion',
        peer,
        usuario: peer,
        twilio: this.numeroTwilio || null,
        marcaPrompt: this.marcaPrompt || 'INBI_CDMX',
      }
      if (this.idAgenteSeleccionado) {
        base.id_agente = this.idAgenteSeleccionado
      }
      if (this.versionAgenteSeleccionada != null && this.versionAgenteSeleccionada !== '') {
        base.version_agente = this.versionAgenteSeleccionada
      }
      return base
    },
  },

  methods: {
    avisoIa(payload = {}) {
      const mensaje = payload.text || payload.mensaje || ''
      const color = payload.color || 'info'
      if (color === 'error' && typeof this.validarError === 'function') {
        this.validarError(mensaje)
        return
      }
      if (color === 'success' && typeof this.validarSuccess === 'function') {
        this.validarSuccess(mensaje)
        return
      }
      if (typeof this.validarError === 'function' && color === 'warning') {
        this.validarError(mensaje)
        return
      }
      this.$store.commit('mostrarAlerta', { mensaje, tipo: color })
    },

    asegurarAgenteSeleccionado(opts = {}) {
      const silent = !!opts.silent
      if (this.idAgenteSeleccionado) return true
      this.seleccionarAgenteEduardoPreferido()
      if (this.idAgenteSeleccionado) return true
      if (!silent) {
        this.avisoIa({
          text: 'Elige un agente IA en ⚙ antes de continuar.',
          color: 'warning',
        })
        this.panelIaMinimizado = false
      }
      return false
    },

    /** Producción: id exacto "Eduardo" + versión publicada (misma regla que el hook). */
    seleccionarAgenteEduardoPreferido() {
      const lista = this.agentesLista || []
      if (!lista.length) return null
      const preferido = lista.find((a) => a.id_agente === 'Eduardo')
        || lista.find((a) => String(a.id_agente || '').toLowerCase() === 'eduardo')
        || lista.find((a) => {
          const n = String(a.nombre_publico || a.nombre_asesor || '').toLowerCase()
          return n === 'eduardo' || n.includes('eduardo')
        })
        || lista.find((a) => a.version_publicada)
        || lista[0]
      if (preferido) {
        this.idAgenteSeleccionado = preferido.id_agente
      }
      return preferido
    },

    async cargarListaAgentesIa() {
      try {
        const res = await this.$http.get('vendedor-ia.agentes', { params: { solo_activos: '1' } })
        this.agentesLista = (res.data && res.data.agentes) || (res.body && res.body.agentes) || []
        if (!this.idAgenteSeleccionado) {
          this.seleccionarAgenteEduardoPreferido()
          if (this.idAgenteSeleccionado) {
            await this.cargarVersionesAgenteSeleccionado()
          }
        }
      } catch (_) {
        this.agentesLista = []
      }
    },

    async cargarVersionesAgenteSeleccionado() {
      this.versionesAgenteActivo = []
      if (!this.idAgenteSeleccionado) {
        this.versionAgenteSeleccionada = null
        return
      }
      try {
        const res = await this.$http.get(`vendedor-ia.agentes/${this.idAgenteSeleccionado}/versiones`)
        this.versionesAgenteActivo = (res.data && res.data.versiones) || (res.body && res.body.versiones) || []
        const pub = this.versionesAgenteActivo.find((v) => v.estado_version === 'publicado')
        if (pub) this.versionAgenteSeleccionada = String(pub.numero_version)
        else if (this.versionesAgenteActivo[0]) {
          this.versionAgenteSeleccionada = String(this.versionesAgenteActivo[0].numero_version)
        } else {
          this.versionAgenteSeleccionada = null
        }
      } catch (_) {
        this.versionesAgenteActivo = []
        this.versionAgenteSeleccionada = null
      }
    },

    async onCambioIdAgenteIa() {
      if (this.idAgenteSeleccionado) {
        await this.cargarVersionesAgenteSeleccionado()
      } else {
        this.versionesAgenteActivo = []
        this.versionAgenteSeleccionada = null
      }
      await this.fijarAgenteEnConversacionActiva()
      await this.cargarModoOperacionAgente()
    },

    async onCambioVersionAgenteIa() {
      await this.fijarAgenteEnConversacionActiva()
      await this.cargarModoOperacionAgente()
    },

    async fijarAgenteEnConversacionActiva() {
      const idConv = this.idConversacionActiva
      if (!idConv || !this.idAgenteSeleccionado) return
      try {
        const body = {
          id_agente: this.idAgenteSeleccionado,
          forzar: true,
        }
        if (this.versionAgenteSeleccionada != null && this.versionAgenteSeleccionada !== '') {
          body.version_agente = this.versionAgenteSeleccionada
        }
        const res = await this.$http.post(
          `vendedor-ia.agentes.conversacion/${idConv}/fijar`,
          body,
        )
        const payload = res.body || res.data || {}
        if (payload.modo_operacion) this.modoOperacionAgente = payload.modo_operacion
        if (payload.version_agente != null) {
          this.versionAgenteSeleccionada = String(payload.version_agente)
        }
      } catch (_) { /* conversación aún no existe */ }
    },

    async cargarModoOperacionAgente() {
      const idConv = this.idConversacionActiva
      if (!idConv) return
      try {
        const res = await this.$http.get(`vendedor-ia.agentes.conversacion/${idConv}/modo`)
        const payload = res.body || res.data || {}
        if (payload.modo_operacion) this.modoOperacionAgente = payload.modo_operacion
        if (payload.id_agente && !this.idAgenteSeleccionado) {
          this.idAgenteSeleccionado = payload.id_agente
          await this.cargarVersionesAgenteSeleccionado()
        }
      } catch (_) { /* noop */ }
    },

    resetPanelIaChat() {
      this.contextoActivo = null
      this.perfilActivo = null
      this.borradorActivo = null
      this.borradores = []
      this.controlEstado = null
      this.tabIa = 0
    },

    async alAbrirChatPanelIa() {
      this.resetPanelIaChat()
      if (!this.chat) return
      if (!this.idAgenteSeleccionado) {
        this.seleccionarAgenteEduardoPreferido()
        if (this.idAgenteSeleccionado) {
          await this.cargarVersionesAgenteSeleccionado()
        }
      }
      await this.cargarControlEstado(true)
      await this.cargarModoOperacionAgente()
      await this.cargarBorradores(true)
      // Contexto automático (antes: clic manual en ⚙ → Cargar contexto)
      await this.cargarContextoIa(true)
    },

    /** Socket en vivo: refrescar panel IA sin reenviar WhatsApp. */
    onMensajeTwilioEnVivo(row) {
      if (!this.chat || !row) return
      if (row.usuario !== this.chat.usuario) return
      // Outbound de la IA (mio=1) o inbound: refrescar borradores/contexto en silencio
      clearTimeout(this._iaSocketRefreshTimer)
      this._iaSocketRefreshTimer = setTimeout(() => {
        this.cargarBorradores(true)
        this.cargarContextoIa(true)
        this.cargarControlEstado(true)
      }, 400)
    },

    sincronizarControlDesdePerfil(perfil) {
      if (!perfil) return
      if (perfil.control_conversacion == null && perfil.humano_tomo_control == null) return
      this.controlEstado = {
        ...(this.controlEstado || {}),
        control_conversacion: perfil.control_conversacion || 'ia',
        ia_puede_responder: perfil.ia_puede_responder !== false,
        humano_tomo_control: !!perfil.humano_tomo_control,
        id_humano_control: perfil.id_humano_control || null,
        fuente: perfil.control_fuente || 'envelope',
      }
    },

    async cargarControlEstado(silent = false) {
      if (!this.chat || !this.payloadIaBase) return
      if (!silent) this.cargandoControl = true
      try {
        const res = await this.$http.post('vendedor-ia.control.estado', this.payloadIaBase)
        const payload = res.body || res.data || {}
        if (payload.estado) this.controlEstado = payload.estado
      } catch (e) {
        if (!silent) {
          const msg = (e.body && e.body.message)
            || (e.response && e.response.data && e.response.data.message)
            || 'No se pudo leer el control'
          this.avisoIa({ text: msg, color: 'warning' })
        }
      } finally {
        if (!silent) this.cargandoControl = false
      }
    },

    async tomarControlConversacion() {
      if (!this.chat || !this.payloadIaBase) return
      this.accionControl = true
      try {
        const res = await this.$http.post('vendedor-ia.control.tomar', {
          ...this.payloadIaBase,
          motivo: 'takeover_asesora_agente',
        })
        const payload = res.body || res.data || {}
        if (payload.estado) this.controlEstado = payload.estado
        if (payload.perfil) {
          this.perfilActivo = payload.perfil
          if (this.contextoActivo) {
            this.contextoActivo = { ...this.contextoActivo, perfil: payload.perfil }
          }
        }
        this.avisoIa({
          text: payload.message || 'Tomaste el control. Ya puedes responder al lead.',
          color: 'success',
        })
      } catch (e) {
        const msg = (e.body && e.body.message)
          || (e.response && e.response.data && e.response.data.message)
          || 'No se pudo tomar el control'
        this.avisoIa({ text: msg, color: 'error' })
      } finally {
        this.accionControl = false
      }
    },

    async devolverControlIa() {
      if (!this.chat || !this.payloadIaBase) return
      this.accionControl = true
      try {
        const res = await this.$http.post('vendedor-ia.control.devolver-ia', this.payloadIaBase)
        const payload = res.body || res.data || {}
        if (payload.estado) this.controlEstado = payload.estado
        if (payload.perfil) {
          this.perfilActivo = payload.perfil
          if (this.contextoActivo) {
            this.contextoActivo = { ...this.contextoActivo, perfil: payload.perfil }
          }
        }
        this.avisoIa({
          text: payload.message || 'Control devuelto a la IA',
          color: 'success',
        })
      } catch (e) {
        const msg = (e.body && e.body.message)
          || (e.response && e.response.data && e.response.data.message)
          || 'No se pudo devolver el control'
        this.avisoIa({ text: msg, color: 'error' })
      } finally {
        this.accionControl = false
      }
    },

    async cargarContextoIa(silent = false) {
      if (!this.chat || !this.payloadIaBase) return
      if (!this.asegurarAgenteSeleccionado({ silent })) return
      if (!silent) this.cargandoContexto = true
      try {
        const res = await this.$http.post('vendedor-ia.contexto', this.payloadIaBase)
        this.contextoActivo = res.body || res.data || null
        this.perfilActivo = (this.contextoActivo && this.contextoActivo.perfil) || null
        this.sincronizarControlDesdePerfil(this.perfilActivo)
        if (!silent) {
          this.tabIa = 0
          this.panelIaMinimizado = false
        }
        this.cargarControlEstado(true)
      } catch (e) {
        if (!silent) {
          const msg = (e.body && e.body.message)
            || (e.response && e.response.data && e.response.data.message)
            || 'No se pudo armar el contexto'
          this.avisoIa({ text: msg, color: 'error' })
        }
      } finally {
        if (!silent) this.cargandoContexto = false
      }
    },

    async copiarContextoIaJson() {
      if (!this.jsonContextoIa) {
        this.avisoIa({ text: 'No hay contexto_ia. Carga el contexto primero.', color: 'warning' })
        return
      }
      const texto = JSON.stringify(this.jsonContextoIa, null, 2)
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(texto)
        } else {
          const ta = document.createElement('textarea')
          ta.value = texto
          ta.setAttribute('readonly', '')
          ta.style.position = 'absolute'
          ta.style.left = '-9999px'
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }
        this.avisoIa({ text: 'contexto_ia copiado', color: 'success' })
      } catch (_) {
        this.avisoIa({ text: 'No se pudo copiar al portapapeles', color: 'error' })
      }
    },

    async cargarBorradores(silent = false) {
      if (!this.chat) return
      try {
        const res = await this.$http.get('vendedor-ia.borradores', {
          params: {
            twilio: this.numeroTwilio,
            usuario: this.chat.usuario,
            limit: 10,
          },
        })
        const payload = res.body || res.data || {}
        this.borradores = payload.borradores || []
        if (this.borradores.length && !this.borradorActivo) {
          this.borradorActivo = this.borradores[0]
        }
      } catch (_) {
        if (!silent) { /* silencioso en apertura de chat */ }
      }
    },

    textoWhatsAppDesdeBorrador(borrador) {
      const raw = String(borrador || '').trim()
      if (!raw) return ''
      const match = raw.match(/RESPUESTA\s+PARA\s+WHATSAPP\s*:?\s*\r?\n([\s\S]*)$/i)
      if (match && match[1].trim()) return match[1].trim()
      const sameLine = raw.match(/RESPUESTA\s+PARA\s+WHATSAPP\s*:\s*(.+)$/i)
      if (sameLine && sameLine[1].trim()) return sameLine[1].trim()
      if (!/DATOS\s+DETECTADOS/i.test(raw)) return raw
      return ''
    },

    textoParaEnviarWhatsApp(borradorObj = this.borradorActivo) {
      if (!borradorObj) return ''
      const directo = String(borradorObj.borrador_whatsapp || '').trim()
      if (directo) return directo
      return this.textoWhatsAppDesdeBorrador(borradorObj.borrador || borradorObj.texto)
    },

    async generarBorradorIa() {
      if (!this.chat || !this.payloadIaBase) return false
      if (!this.asegurarAgenteSeleccionado()) return false
      if (this.generandoBorrador) return false
      if (this.iaBloqueadaPorHumano) {
        this.avisoIa({
          text: 'Tomaste el control: la IA no genera borradores hasta que la reactives.',
          color: 'warning',
        })
        return false
      }
      this.generandoBorrador = true
      try {
        // Solo lectura/diagnóstico: el envío WhatsApp lo hace el webhook (hook), no el front
        const res = await this.$http.post('vendedor-ia.borrador', {
          ...this.payloadIaBase,
          promptId: 'INBI_ETAPA_CALIFICACION_INICIAL',
          modoPrueba: false,
        })
        const payload = res.body || res.data || {}
        if (payload.modo_operacion) this.modoOperacionAgente = payload.modo_operacion
        const borradorCompleto = payload.borrador || ''
        const wa = String(payload.borrador_whatsapp || '').trim()
          || this.textoWhatsAppDesdeBorrador(borradorCompleto)
          || (payload.duplicado ? '¿En qué puedo ayudarte?' : '')
          || (borradorCompleto ? '¿En qué puedo ayudarte?' : '')
        this.borradorActivo = {
          id: payload.id,
          borrador: borradorCompleto || wa,
          borrador_whatsapp: wa,
          adjuntos: Array.isArray(payload.adjuntos) ? payload.adjuntos : [],
          herramientas_ejecutadas: payload.herramientas_ejecutadas || [],
          prompt_version: payload.prompt_version,
          fecha_creacion: new Date().toISOString(),
          texto: borradorCompleto || wa,
        }
        if (payload.contexto) this.contextoActivo = payload.contexto
        if (payload.perfil) {
          this.perfilActivo = payload.perfil
          this.sincronizarControlDesdePerfil(payload.perfil)
          if (this.contextoActivo) {
            this.contextoActivo = { ...this.contextoActivo, perfil: payload.perfil }
          }
        }
        await this.cargarBorradores(true)
        this.tabIa = 1
        this.panelIaMinimizado = false
        this.avisoIa({
          text: payload.duplicado
            ? 'Borrador ya existía (sin reenviar). La IA responde sola por el webhook.'
            : 'Borrador listo. En producción el webhook envía solo; aquí solo visualizas.',
          color: 'info',
        })
        return true
      } catch (e) {
        const body = (e.body) || (e.response && e.response.data) || {}
        const msg = body.message || 'No se pudo generar la respuesta IA'
        if (body.bloqueado || body.codigo === 'HUMANO_ACTIVO' || body.transferido || e.status === 403 || e.status === 422) {
          if (body.estado_control) this.controlEstado = body.estado_control
          else this.cargarControlEstado(true)
        }
        this.avisoIa({ text: msg, color: 'error' })
        return false
      } finally {
        this.generandoBorrador = false
      }
    },

    /**
     * @deprecated El envío lo hace el hook (`twilio.hooks` → twilio-agente-ia).
     * Se conserva por si se necesita un fallback manual controlado.
     */
    async enviarBorradorIaWhatsAppProduccion() {
      this.avisoIa({
        text: 'El envío automático lo hace el servidor (webhook). No se envía desde el front.',
        color: 'info',
      })
      return false
    },

    abrirDialogReiniciarContexto() {
      if (!this.chat) return
      this.modoLimpiarAgente = 'contexto'
      this.dialogLimpiarAgente = true
    },

    abrirDialogBorrarConversacion() {
      if (!this.chat) return
      this.modoLimpiarAgente = 'todo'
      this.dialogLimpiarAgente = true
    },

    async confirmarLimpiarAgente() {
      if (!this.chat || !this.chat.usuario) return
      this.limpiandoAgente = true
      try {
        const res = await this.$http.post('twilio.agente.limpiar', {
          peer: this.chat.usuario,
          usuario: this.chat.usuario,
          twilio: this.numeroTwilio,
          modo: this.modoLimpiarAgente,
        })
        const payload = res.body || res.data || {}
        this.dialogLimpiarAgente = false

        this.borradorActivo = null
        this.borradores = []
        this.contextoActivo = null
        this.perfilActivo = null
        this.controlEstado = null

        if (this.modoLimpiarAgente === 'todo') {
          this.mensajes = []
          if (this.chat) {
            this.chat.mensaje = 'Sin mensajes'
            this.chat.sinleer = 0
          }
          this.avisoIa({
            text: payload.message
              || `Conversación borrada (${payload.mensajes_eliminados || 0} msgs). Contexto reiniciado.`,
            color: 'success',
          })
          if (typeof this.initialize === 'function') {
            await this.initialize(1)
          }
        } else {
          this.avisoIa({
            text: payload.message || 'Contexto IA reiniciado. Mensajes conservados.',
            color: 'success',
          })
          await this.cargarContextoIa(true)
          await this.cargarControlEstado(true)
          await this.cargarBorradores(true)
        }

        // Re-seleccionar Eduardo en UI
        this.seleccionarAgenteEduardoPreferido()
        if (this.idAgenteSeleccionado) {
          await this.cargarVersionesAgenteSeleccionado()
          await this.fijarAgenteEnConversacionActiva()
        }
      } catch (e) {
        const msg = (e.body && e.body.message)
          || (e.response && e.response.data && e.response.data.message)
          || 'No se pudo limpiar'
        this.avisoIa({ text: msg, color: 'error' })
      } finally {
        this.limpiandoAgente = false
      }
    },
  },
}
